import { render, staticRenderFns } from "./BaseQuotedMessage.vue?vue&type=template&id=1465a8ce&scoped=true"
import script from "./BaseQuotedMessage.vue?vue&type=script&lang=js"
export * from "./BaseQuotedMessage.vue?vue&type=script&lang=js"
import style0 from "./BaseQuotedMessage.vue?vue&type=style&index=0&id=1465a8ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465a8ce",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
